import * as React from "react";
import { SVGProps } from "react";
const FavIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19.087}
    height={17.02}
    {...props}
  >
    <g data-name="Group 18337">
      <g data-name="Group 18336">
        <g data-name="Component 6452 \u2013 97">
          <path
            fill={props.fill ?? "rgba(0,0,0,0)"}
            stroke={props.stroke ?? "#647188"}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m17.047 9.098-7.495 7.423-7.493-7.423a5 5 0 1 1 7.494-6.566 5 5 0 1 1 7.495 6.567"
            data-name="Path 5827"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default FavIcon;
